import React, { useRef, useCallback, FC } from 'react';

import { StyledTimePicker } from '../styled';

import { TIME_FORMAT } from './const';

import TimeList from './TimeList';

import locale from 'antd/lib/date-picker/locale/ru_RU';

import { useTimeState } from './hooks';

import { TimePickerProps } from '../types';

const TimePicker: FC<TimePickerProps> = ({
  value: externalValue,
  hourStep,
  minuteStep,
  defaultValue,
  disabledHours,
  disabledMinutes,
  hideDisabledOptions,
  onChange = () => null,
  ...props
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = useRef<any>(null); // TODO: set valid type
  const [value, setValue] = useTimeState<TimePickerProps['value']>({
    defaultValue,
    value: externalValue,
  });

  const handleChange = useCallback(
    (time: Exclude<TimePickerProps['value'], undefined> = null) => {
      setValue(time);
      onChange(time, time ? time.format(TIME_FORMAT) : '');
      ref.current?.blur();
    },
    [onChange, setValue],
  );

  return (
    <StyledTimePicker
      ref={ref}
      value={value}
      panelRender={() => (
        <TimeList
          value={value}
          disabledHours={disabledHours}
          disabledMinutes={disabledMinutes}
          minuteStep={minuteStep}
          hourStep={hourStep}
          hideDisabledOptions={hideDisabledOptions}
          onChange={handleChange}
        />
      )}
      {...props}
    />
  );
};

TimePicker.defaultProps = {
  placeholder: 'ЧЧ:ММ',
  format: ['HH:mm', 'HHm', 'HH', 'H'],
  showNow: false,
  locale: locale,
  minuteStep: 30,
  getPopupContainer: node => node || document.body,
};

export default TimePicker;
